import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import firebase from 'firebase/app';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

import './index.css';
import Upload from './Upload';
import Download from './Download';
import Home from './Home';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Keywords from './Keywords';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#7e3db0',
    },
  },
});

const firebaseConfig = {
  apiKey: "AIzaSyD96vaZq2Ps5mH92yhlOQZtuDTWwL6soGY",
  authDomain: "design-minds-boutique.firebaseapp.com",
  databaseURL: "https://design-minds-boutique.firebaseio.com",
  projectId: "design-minds-boutique",
  storageBucket: "design-minds-boutique.appspot.com",
  messagingSenderId: "335745591180",
  appId: "1:335745591180:web:f3f44dbfc1ad571228d8a9",
  measurementId: "G-GL4Q0BT9CE"
};
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <BrowserRouter>
      <Switch>
        <Route path="/canada" component={() => {
          window.location.href = 'https://www.redbubble.com/people/designminds/shop?artistUserName=designminds&asc=u&collections=902102&iaCode=u-tees&sortOrder=relevant';
          return null;
        }} />
        <Route path="/upload">
          <Upload />
        </Route>
        <Route path="/download/:id">
          <Download />
        </Route>
        <Route path="/keywords">
          <Keywords />
        </Route>
        <Route path="*">
          <Home />
        </Route>
      </Switch>
    </BrowserRouter>
  </MuiThemeProvider >,
  document.getElementById('root')
);